export const enumLang = {
  ru: 'ru',
  eng: 'en'
}
